import { useFormikContext } from 'formik';
import { MatchMakerAnswers } from '../../../../shared/types';
import { MonthlyBudgetInput } from './components/MonthlyBudgetInput';

export const ExpectedMonthlyPayment: React.FC = () => {
  const { values } = useFormikContext<MatchMakerAnswers>();

  return <MonthlyBudgetInput values={values} />;
};
